import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from '@heroicons/react/24/outline';

const linkCardClass =
  'flex items-center justify-between p-3 bg-white rounded-md border border-gray-200 hover:border-blue-300 hover:shadow-md transition-all duration-200 group';

const isExternalHref = (href) => typeof href === 'string' && /^https?:\/\//i.test(href);

const InternalLinks = ({ 
  title = "Related Solutions", 
  links = [],
  className = "" 
}) => {
  if (!links || links.length === 0) return null;

  return (
    <div className={`bg-gray-50 rounded-lg p-6 ${className}`}>
      <h3 className="text-lg font-semibold text-gray-900 mb-4">{title}</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {links.map((link, index) => {
          const href = link.href || link.path;
          const external = link.external === true || isExternalHref(href);

          const inner = (
            <>
              <div className="flex items-center space-x-3">
                {link.icon && (
                  <div className="text-blue-600 group-hover:text-blue-700">
                    {link.icon}
                  </div>
                )}
                <div>
                  <div className="font-medium text-gray-900 group-hover:text-blue-700">
                    {link.title}
                  </div>
                  {link.description && (
                    <div className="text-sm text-gray-600">
                      {link.description}
                    </div>
                  )}
                </div>
              </div>
              <ArrowRightIcon className="w-4 h-4 text-gray-400 group-hover:text-blue-600 transition-colors shrink-0" />
            </>
          );

          if (external) {
            return (
              <a
                key={index}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className={linkCardClass}
              >
                {inner}
              </a>
            );
          }

          return (
            <Link key={index} to={link.path} className={linkCardClass}>
              {inner}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default InternalLinks;


